import React, { useState, useEffect } from 'react'
import Loading from '../loaders/Loading'
import { useSelector, useDispatch } from 'react-redux'
import { userSelectors } from '../../redux/userSlice'
import { syncCartWithBackend } from '../../pages/Cart/cartApi'
import { UserTypes } from '../../util/constants'
import {
    cartSelectors,
    CartMode,
    cartActions,
} from '../../pages/Cart/cartSlice'
import { getCompanyLogo, getUserProfile } from '../../api/userApi'
import { getWishList } from '../../pages/WishList/wishListApi'

export function PrefetchGate({ children }) {
    const [canRender, setCanRender] = useState(false)
    const [forceError, setForceError] = useState(null)

    const dispatch = useDispatch()
    const isLoggedIn = useSelector(userSelectors.isLoggedIn)
    const user = useSelector(userSelectors.userDetails)
    const cartMode = useSelector(cartSelectors.mode)

    const isBeneficiary = user.userType === UserTypes.Beneficiary
    const isBusiness = user.userType === UserTypes.Business

    useEffect(() => {
        async function loadRequiredItems() {
            // The user is not logged in but the cart is linked to the server
            // e.g. user state has expired, reset the cart to client side
            if (!isLoggedIn && cartMode === CartMode.ServerSide) {
                dispatch(cartActions.resetCart())
            }

            if (isLoggedIn) {
                await dispatch(getUserProfile()).then(async successful => {
                    // If the user profile fails to load, the user gets logged out
                    // So fetching these is useless then
                    if (successful) {
                        const requests = []
                        if (isBusiness) {
                            requests.push(dispatch(getCompanyLogo()))
                        }

                        if (!isBeneficiary) {
                            requests.push(
                                dispatch(syncCartWithBackend()),
                                dispatch(getWishList(user.email))
                            )
                        }

                        await Promise.all(requests)
                    }
                })
            }
        }

        loadRequiredItems()
            .then(() => {
                setCanRender(true)
            })
            .catch(error => {
                setForceError(error)
            })
    }, [isLoggedIn, dispatch, isBeneficiary, cartMode])

    // Force the error boundary to show/pick up the error
    if (forceError) throw forceError

    if (canRender) {
        return children
    } else {
        return <Loading />
    }
}
